import { render } from "./SalesEdit.vue?vue&type=template&id=f22e5be8&scoped=true"
import script from "./SalesEdit.vue?vue&type=script&lang=js"
export * from "./SalesEdit.vue?vue&type=script&lang=js"

import "./SalesEdit.vue?vue&type=style&index=0&id=f22e5be8&lang=scss&scoped=true"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f22e5be8"]])

export default __exports__